import { getFromAPI } from '@/lib/api';
import { IntroAttributes, StrapiAPIResponseSingle } from '@/lib/apiTypes';
import { useEffect, useState } from 'react';
import useKeyValueStorage from './storage/useKeyValueStorage';
import useVideo from './useVideo';

const useIntro = () => {
	const { value: intro, setValue: setIntro } = useKeyValueStorage<
		IntroAttributes | undefined
	>('intro', undefined);

	const { audioDescriptionFile, subtitlesBase64, isError } = useVideo({
		video: intro?.video,
	});

	const [introError, setIntroError] = useState<boolean>(false);
	const { value: hasSeenIntro, setValue: setHasSeenIntro } =
		useKeyValueStorage('hasSeenIntro', false);

	useEffect(() => {
		getFromAPI('intro')
			.then((data) => {
				const introAttributes = (
					data as StrapiAPIResponseSingle<IntroAttributes>
				).data.attributes;
				setIntro(introAttributes);
			})
			.catch(() => {
				setIntroError(true);
			});
	}, [setIntro]);

	return {
		intro,
		introSubtitlesBase64: subtitlesBase64,
		introAudioDescriptionFile: audioDescriptionFile,
		isLoadingIntro: !intro && !hasSeenIntro && !introError,
		isError: !!introError || !!isError,
		hasSeenIntro,
		setHasSeenIntro,
	};
};

export default useIntro;
